import makeStyles from "e100-react-components/lib/styles/makeStyles";

const useStyles = makeStyles(({ typography, palette }) => ({
  button: {
    fontWeight: 700,
    color: palette.text.primary
  },
  buttonIcon: {
    fontSize: `${typography.h5.fontSize} !important`
  }
}));

export default useStyles;
